import { render, staticRenderFns } from "./addBomFromInherit.vue?vue&type=template&id=e455c06a&scoped=true&"
import script from "./addBomFromInherit.vue?vue&type=script&lang=js&"
export * from "./addBomFromInherit.vue?vue&type=script&lang=js&"
import style0 from "./addBomFromInherit.vue?vue&type=style&index=0&id=e455c06a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e455c06a",
  null
  
)

export default component.exports